export default "__VITE_ASSET__CrxY1EuV__"